import React from "react"
import styled from "styled-components"

export interface ICompanyDetailCard {
  icon: React.ReactNode
  count: string
  title: string
  isActive?: boolean
  onClick?: () => void
}
const IconStyle = styled.div`
  height: 50px;
  width: 50px;

  svg {
    height: 100%;
    width: 100%;
    fill: ${(props) => props.theme.base};
  }
  @media (max-width: 1023px) {
    height: 32px;
    width: 32px;
  }
`
const CardWrapper = styled.div<{ isActive: boolean }>`
  border: 2px solid
    ${(props) =>
      props.isActive ? props.theme.borderHoverColor : props.theme.borderColor};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${(props) =>
    props.isActive ? props.theme.hoverBlue : props.theme.base};
  background-color: ${(props) =>
    props.isActive ? props.theme.base : props.theme.detailSectionBgColor};
  transition: background-color 0.3s ease, border 0.3s ease, color 0.3s ease;
  cursor: pointer;
  padding: 36px;

  svg {
    transition: fill 0.3s ease;
    fill: ${(props) =>
      props.isActive ? props.theme.hoverBlue : props.theme.base};
  }

  &:hover {
    border: 2px solid ${(props) => props.theme.borderHoverColor};
    color: ${(props) => props.theme.hoverBlue};
    background-color: ${(props) => props.theme.base};
    svg {
      stroke: none;
      fill: ${(props) => props.theme.hoverBlue};
    }
  }
`
const CountStyle = styled.div`
  ${(props) => props.theme.typography.headline4}
  margin-top: 8px;
  @media (max-width: 1023px) {
    font-size: 1.25rem;
  }
`
const TitleStyle = styled.div`
  ${(props) => props.theme.typography.navMobItemFont}
  font-family: Lato, sans-serif;
  text-align: center;
  @media (max-width: 576px) {
    font-size: 0.75rem;
  }
`

export const CompanyDetailCard: React.FC<ICompanyDetailCard> = ({
  icon,
  count,
  title,
  isActive = false,
  onClick,
}) => {
  return (
    <CardWrapper isActive={isActive} onClick={onClick}>
      <IconStyle>{icon}</IconStyle>
      <CountStyle>{count}</CountStyle>
      <TitleStyle>{title.toLocaleUpperCase()}</TitleStyle>
    </CardWrapper>
  )
}
